/* eslint-disable lit/binding-positions */
import './buttons/buttons.component';
import './menu-profile.component';

import { projectSharedCss } from '@app/projects/list/style.css';
import { PrefetchService } from '@core/prefetch/prefetch.service';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { ProjectsService } from '@core/services/projects/projects.service';
import { TranslateModifiers } from '@core/translate';
import { IProjectType } from '@introspection/index';
import { Component, DefineDependencies } from '@rhtml/component';
import { Container, Inject } from '@rxdi/core';
import { classMap, css, html, LitElement, svg } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';
import { ResponsiveService } from '@rxdi/ui-components/services';
import { Logo } from '@shared/icons/logo';
import { changeTheme } from '@shared/palettes';
import { BxDropdownStyle } from '@shared/styles/bx-dropdown.style';
import { SocialService } from '@stradivario/graphql-server';
import { combineLatest, of } from 'rxjs';
import { catchError, map, startWith, switchMap, tap } from 'rxjs/operators';

const style = css`
  ${projectSharedCss}
  .spacer {
    flex: 1 3 auto;
  }
  .center {
    text-align: center;
  }
  .pointer {
    cursor: pointer;
  }
  a {
    text-decoration: none;
  }
  h2 {
    cursor: pointer;
    padding: 10px 20px;
    position: relative;
    font-size: 1.25em;
    cursor: pointer;
    margin: 0px;
    font-weight: 400;
  }

  h2:after {
    background: none repeat scroll 0 0 transparent;
    bottom: 0;
    content: '';
    display: block;
    height: 2px;
    left: 50%;
    position: absolute;
    background: #c1c9d3;
    transition: width 0.3s ease 0s, left 0.3s ease 0s;
    width: 0;
  }
  h2:hover:after {
    width: 100%;
    left: 0;
  }
  @media screen and (max-height: 300px) {
    ul {
      margin-top: 40px;
    }
  }

  .container2 {
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.22);
  }
  /* .container2 {
  box-shadow: 0 5px 5px rgba(162, 162, 162, 0.25),
    0 5px 5px rgba(0, 0, 0, 0.22);
} */
  .element {
    -webkit-transition: height 2s; /* For Safari 3.1 to 6.0 */
    transition: height 2s;
  }

  .profile-dropdown:hover {
    opacity: 0.7;
  }

  nav {
    box-shadow: rgb(0 0 0 / 8%) 0px 1px 2px, rgb(0 0 0 / 14%) 0px 1px 2px;
  }

  nav:hover {
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s;
  }
`;

const Providers = DefineDependencies(ResponsiveService, SocialService, ProjectsService, LocalStorageService)(Container);

interface State {
  projects: IProjectType[];
  isLoggedIn: boolean;
  isNavbarOpened: boolean;
  isMobile: boolean;
  theme: 'dark' | 'light';
  selectedProject?: { data: unknown; name: string };
}
/**
 * @customElement navbar-component
 */
@Component<State, typeof Providers, NavbarComponent>({
  Settings: {
    selector: 'navbar-component',
    style: css`
      ${style} .anim-rotate {
        animation: rotate 1s linear infinite;
      }
      nav {
        display: flex;
        padding: 0.7rem;
      }
      @media screen and (max-width: 640px) {
        nav {
          display: block;
        }
      }

      div {
        user-select: none;
      }

      ${BxDropdownStyle}

      bx-dropdown::part(trigger-button) {
        width: 160px;
      }
    `,
    modifiers: [...TranslateModifiers],
  },
  Providers,
  State(this, [responsive, socialService, projectService, localStorage]) {
    return combineLatest([
      socialService.checkLoggedIn().pipe(
        startWith(false),
        switchMap((loggedIn) =>
          loggedIn
            ? projectService.listProjects().pipe(
                startWith([]),
                catchError(() => of([]))
              )
            : of([])
        )
      ),
      socialService.isLoggedIn.pipe(startWith(false)),
      responsive.width.pipe(
        startWith(window.innerWidth),
        map((width) => width > 600)
      ),
      responsive.width.pipe(
        startWith(window.innerWidth),
        map((width) => width < 600)
      ),
      localStorage.onUpdated('selected-project').pipe(startWith(null as never)),
    ]).pipe(
      map(([projects, isLoggedIn, isNavbarOpened, isMobile, selectedProject]) => ({
        projects,
        isLoggedIn,
        isNavbarOpened,
        isMobile,
        theme: localStorage.get('dark-mode') || 'light',
        selectedProject,
      }))
    );
  },
  Render: ([, , , localStorage]) =>
    function (this, state, setState) {
      const { projects, isLoggedIn, isNavbarOpened, isMobile, theme } = state;
      return html`
        <!-- <div style="animation: rotate 1s linear infinite">
    ${svg`<svg width="20px" height="20px" fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path opacity=".5" d="M8 15A7 7 0 108 1a7 7 0 000 14v0z" stroke="#dbab0a" stroke-width="2"></path>
        <path d="M15 8a7 7 0 01-7 7" stroke="#dbab0a" stroke-width="2"></path>
        <path d="M8 12a4 4 0 100-8 4 4 0 000 8z" fill="#dbab0a"></path>
      </svg>`}
   </div> -->

        <nav>
          <div style="display: flex">
            <div @click=${() => this.router.go(isLoggedIn ? '/projects' : '')} style="cursor: pointer; display: flex">
              <span style="width:40px;">${Logo}</span>
              <div
                style="white-space: nowrap;position: relative;margin-left: 10px; font-size: 18px; margin-top: 10px; font-weight: bold;"
              >
                Graphql Server
              </div>
            </div>
            <span class="spacer"></span>
            ${isMobile
              ? html`<div>
                  <hamburger-component
                    @click=${() => {
                      state.isNavbarOpened = !isNavbarOpened;
                      setState({ ...state });
                    }}
                    .active=${isNavbarOpened}
                  ></hamburger-component>
                </div>`
              : html``}
          </div>
          <span class="spacer"></span>

          ${isNavbarOpened
            ? html`
                ${isLoggedIn
                  ? html`
                      <div>
                        <a
                          @click=${() => {
                            this.router.go('/apps');
                          }}
                        >
                          <h2 translate>Apps</h2>
                        </a>
                      </div>

                      <!-- <div>
              <a
               @mouseover=${() => this.prefetch.fetch(import('../teams/teams.module'))}
               @click=${() => {
                        this.router.go('/teams');
                      }}
              >
               <h2>Teams</h2>
              </a>
             </div> -->
                      <div style="  margin-right: 15px;">
                        <a
                          @mouseover=${() => this.prefetch.fetch(import('../projects/projects.module'))}
                          @click=${() => {
                            this.router.go('/projects');
                          }}
                        >
                          <h2 translate>Projects</h2>
                        </a>
                      </div>

                      <div style="display: flex">
                        <div style="position: relative; top: 5px;">
                          ${projects.length
                            ? html`
                                <div>
                                  <div style="margin-right: 10px;">
                                    <bx-dropdown
                                      @bx-dropdown-selected=${(e) => {
                                        const project = projects.find((p) => p.id === e.currentTarget.value);
                                        localStorage.update('selected-project', project?.name);
                                        this.router.go(`/projects/${e.currentTarget.value}`);
                                      }}
                                      trigger-content=${(localStorage.get<string>('selected-project') ||
                                        projects[0]?.name) as string}
                                    >
                                      ${projects.map(
                                        (project: IProjectType) =>
                                          html`<bx-dropdown-item value=${project.id}
                                            >${project.name}</bx-dropdown-item
                                          > `
                                      )}
                                    </bx-dropdown>
                                  </div>
                                </div>
                              `
                            : ''}
                        </div>
                        <div
                          style="top: 6px;position: relative;cursor: pointer; padding-right:10px;"
                          @click=${() => {
                            state.theme = theme === 'light' ? 'dark' : 'light';
                            setState({ ...state });
                            changeTheme(state.theme);
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 16 16"
                            height="34"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M11.67 8.658a3.661 3.661 0 0 0-.781 1.114 3.28 3.28 0 0 0-.268 1.329v1.6a1.304 1.304 0 0 1-.794 1.197 1.282 1.282 0 0 1-.509.102H7.712a1.285 1.285 0 0 1-.922-.379 1.303 1.303 0 0 1-.38-.92v-1.6c0-.479-.092-.921-.274-1.329a3.556 3.556 0 0 0-.776-1.114 4.689 4.689 0 0 1-1.006-1.437A4.187 4.187 0 0 1 4 5.5a4.432 4.432 0 0 1 .616-2.27c.197-.336.432-.64.705-.914a4.6 4.6 0 0 1 .911-.702c.338-.196.7-.348 1.084-.454a4.45 4.45 0 0 1 1.2-.16 4.476 4.476 0 0 1 2.276.614 4.475 4.475 0 0 1 1.622 1.616 4.438 4.438 0 0 1 .616 2.27c0 .617-.117 1.191-.353 1.721a4.69 4.69 0 0 1-1.006 1.437zM9.623 10.5H7.409v2.201c0 .081.028.15.09.212a.29.29 0 0 0 .213.09h1.606a.289.289 0 0 0 .213-.09.286.286 0 0 0 .09-.212V10.5z"
                            ></path>
                          </svg>
                        </div>
                        <div style="position: relative; top: 5px;">
                          <notifications-feed></notifications-feed>
                        </div>
                        <div style="position: relative;top: 5px;">
                          <user-profile-menu></user-profile-menu>
                        </div>
                      </div>
                      <!-- <div></div> -->
                    `
                  : html`
                      <div>
                        <a
                          style="color: var(--global-color, black);"
                          href="https://github.com/Stradivario/gapi"
                          target="_blank"
                          class=${classMap(this.buttonsClass)}
                        >
                          <h2>Github</h2>
                        </a>
                      </div>
                      <div>
                        <a
                          @mouseover=${() => this.prefetch.fetch(import('../roadmap/roadmap.module'))}
                          @click=${() => this.router.go('/roadmap/')}
                          class=${classMap(this.buttonsClass)}
                        >
                          <h2>Roadmap</h2>
                        </a>
                      </div>
                      <div>
                        <a
                          @mouseover=${() => this.prefetch.fetch(import('../pricing/pricing.module'))}
                          @click=${() => this.router.go('/pricing/')}
                          class=${classMap(this.buttonsClass)}
                        >
                          <h2>Pricing</h2>
                        </a>
                      </div>
                      <div>
                        <a
                          @mouseover=${() => this.prefetch.fetch(import('../about/about.module'))}
                          @click=${() => this.router.go('/about/')}
                          class=${classMap(this.buttonsClass)}
                        >
                          <h2>About</h2>
                        </a>
                      </div>
                      <span class="spacer"></span>
                      <div>
                        <a @click=${() => this.router.go('/login/')} class=${classMap(this.buttonsClass)}>
                          <h2>Login</h2>
                        </a>
                      </div>
                      <div>
                        <a @click=${() => this.router.go('/signup/')} class=${classMap(this.buttonsClass)}>
                          <h2>Signup</h2>
                        </a>
                      </div>
                    `}
              `
            : ''}
        </nav>
      `;
    },
})
export class NavbarComponent extends LitElement {
  @Router() router: Router;

  @Inject(PrefetchService)
  public prefetch: PrefetchService;

  public buttonsClass = {
    block: true,
    'mt-4': true,
    'lg:inline-block': true,
    'lg:mt-0': true,
    'hover:text-white': true,
    'mr-5': true,
    center: true,
  };
}
